
export const TransactionHistory = ({ transactions }: { transactions: any[] }) => {
  console.log('TransactionHistory props:', transactions)

  // Verificar que existan las transacciones
  const transactionsList = transactions || [];

  // Si no hay transacciones, mostrar mensaje
  if (!transactionsList || transactionsList.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
        No transactions available
      </div>
    );
  }

  return (
    <>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th className="text-left p-2 border-b border-gray-300">Date</th>
              <th className="text-left p-2 border-b border-gray-300">Description</th>
              <th style={{ textAlign: 'right', padding: '10px', borderBottom: '1px solid #ddd' }}>Amount</th>
              <th className="text-left p-2 border-b border-gray-300">Status</th>
            </tr>
          </thead>
          <tbody>
            {transactionsList.map((transaction) => {
              // Determinar si es una transacción de ingreso o gasto
              const isIncoming = transaction.isIncoming;

              return (
                <tr key={transaction.id || transaction.clientTransactionId || transaction.transactionId}>
                  <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                    {transaction.timestamp || transaction.date || transaction.transactionDate || transaction.createdAt
                      ? new Date(transaction.timestamp || transaction.date || transaction.transactionDate || transaction.createdAt).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric'
                        })
                      : 'N/A'}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                    {/* Ahora usamos displayDescription que contiene el nombre del comerciante */}
                    {transaction.type === "TOP_UP" ? "Card Top-Up" : (transaction.merchantName || 'Purchase')}
                  </td>
                  <td style={{
                    padding: '10px',
                    borderBottom: '1px solid #ddd',
                    textAlign: 'right',
                    color: transaction.type === "TOP_UP" ? '#4CAF50' : '#F44336'
                  }}>
                    {/* {isIncoming ? '+' : '-'} {Math.abs(parseFloat(transaction.amount)).toLocaleString()} € */}
                     {transaction.type === "TOP_UP" ? '+' : '-'} {Math.abs(parseFloat(transaction.amount)).toLocaleString()} €
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>
                    <span style={{
                      display: 'inline-block',
                      backgroundColor: transaction.status === 'PENDING' ? '#fff3cd' : '#d1e7dd',
                      color: transaction.status === 'PENDING' ? '#664d03' : '#0f5132',
                      padding: '5px 10px',
                      borderRadius: '4px',
                      fontSize: '12px'
                    }}>
                      {transaction.status || 'COMPLETED'}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  )
}